module.exports = tribe.common.utils.string;